export var AnalyticsClicksGroups;
(function (AnalyticsClicksGroups) {
    AnalyticsClicksGroups["Text"] = "Text";
    AnalyticsClicksGroups["Menu"] = "Menu";
    AnalyticsClicksGroups["Image"] = "Image";
    AnalyticsClicksGroups["Input"] = "Input";
    AnalyticsClicksGroups["Login"] = "Login";
    AnalyticsClicksGroups["Button"] = "Button";
    AnalyticsClicksGroups["Social"] = "Social";
    AnalyticsClicksGroups["Gallery"] = "Gallery";
    AnalyticsClicksGroups["Community"] = "Community";
    AnalyticsClicksGroups["Decorative"] = "Decorative";
    AnalyticsClicksGroups["MenuAndSearch"] = "MenuAndSearch";
    AnalyticsClicksGroups["MenuAndAnchor"] = "MenuAndAnchor";
})(AnalyticsClicksGroups || (AnalyticsClicksGroups = {}));
//# sourceMappingURL=types.js.map